// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"54292a4b","637":"3960a528","668":"f6fa2ae3"}[chunkId] + ".chunk.js";
};